<template>
  <div class="map-background">
    <div id="login-page" class="login-box">
      <div class="card card-login">
        <div class="card-body">
          <form @submit.prevent="login">
            <div class="row">
              <div class="col-12">
                <img class="sennder-logo mb-3" src="../assets/img/logo_original.svg" />
              </div>
            </div>

            <div v-if="hasGlobalErrors" class="alert alert-dismissible alert-danger">
              <button type="button" class="close" data-dismiss="alert">×</button>
              {{ errors.token }}
              {{ errors.nonFieldErrors }}
              {{ errors.detail }}
            </div>
            <div v-if="loginFailedForGroups" class="alert alert-dismissible alert-danger">
              <button type="button" class="close" data-dismiss="alert">×</button>
              Missing permissions to access otters.
            </div>

            <div v-if="successFeedback" class="alert alert-dismissible alert-success">
              {{ successFeedback }}
            </div>

            <div :class="{ 'form-group': true, 'has-error': errors.username }">
              <div class="input-group">
                <div class="input-group-addon">
                  <i class="material-icons">email</i>
                </div>
                <input
                  type="email"
                  class="form-control"
                  name="username"
                  placeholder="Email"
                  autofocus
                  v-model="email"
                  :disabled="disabled"
                />
              </div>
            </div>
            <div :class="{ 'form-group': true, 'has-error': errors.password }">
              <div class="input-group">
                <div class="input-group-addon">
                  <i class="material-icons">lock</i>
                </div>
                <input
                  type="password"
                  class="form-control"
                  name="password"
                  placeholder="Password"
                  v-model="password"
                  :disabled="disabled"
                />
              </div>
              <div class="form-text">
                <router-link to="/password/reset" class="reset-password">
                  Forgot Password?
                </router-link>
              </div>
            </div>

            <a href="https://www.sennder.com/signup/">
              <button type="button" class="btn btn-raised btn-default">Sign up</button>
            </a>
            <button
              type="submit"
              id="selenium-login"
              class="btn btn-raised btn-primary float-right"
              :disabled="disabled"
            >
              Login
            </button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import formController from '../controllers/form'
  import User from '../models/user'
  import { queryHasOttersPermission } from './queries'

  export default {
  extends: formController,
  data() {
    return {
      email: '',
      password: '',
      loginFailedForGroups: false
    }
  },
  methods: {
    async backendLoginSucceeded() {
      const hasOttersPermission = await queryHasOttersPermission()
      if (hasOttersPermission) {
        this.succeed()
      } else {
        this.loginFailedForGroups = true
      }
    },
    async login() {
      this.loginFailedForGroups = false

      const credentials = { email: this.email, password: this.password }
      const loginPromise = User.login(credentials)
      this.submitted()
      try {
        await loginPromise
        await this.backendLoginSucceeded()
      } catch (errorResponse) {
        // Here, unexpected defects are called. This console log will help debugging,
        // as we currently don't have proper error handling in place.
        console.log(errorResponse)
        this.failed(errorResponse)
      } finally {
        this.always()
      }
    },
    succeed() {
      this.navigate('/')
    }
  }
}
</script>

<style lang="scss">
@import '../styles/_variables.scss';
</style>
